var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguracion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99586 12.1175C10.5681 12.1175 11.1168 11.8943 11.5214 11.4969C11.9261 11.0996 12.1534 10.5607 12.1534 9.99877C12.1534 9.43684 11.9261 8.89793 11.5214 8.50058C11.1168 8.10324 10.5681 7.88002 9.99586 7.88002C9.42366 7.88002 8.87489 8.10324 8.47028 8.50058C8.06567 8.89793 7.83836 9.43684 7.83836 9.99877C7.83836 10.5607 8.06567 11.0996 8.47028 11.4969C8.87489 11.8943 9.42366 12.1175 9.99586 12.1175ZM13.7721 3.64252L17.5484 9.99877L13.7721 16.355H6.21961L2.44336 9.99877L6.21961 3.64252H13.7721Z",
    stroke: "currentColor",
    strokeWidth: 1.711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguracion);
export default __webpack_public_path__ + "static/media/configuracion.86456a05.svg";
export { ForwardRef as ReactComponent };